import client from '../services/client'

/**
 * R-sync-2026-10-21: 统一「持久化当前选中项目」的三个出口。
 *
 * 修复前有三处各写各的(都只写全局 key):
 *   App.jsx handleProjectChange  → 全局 + per-user(不写后端)
 *   ProjectList.handleTileClick  → 只有全局
 *   PortfolioSection onClick     → 只有全局
 * 结果:从后两处切的项目重登后丢失,且没有任何一处同步给服务端,
 * 小程序端登录后只能重新选项目。
 *
 * 现在统一走这里:本地双写 + 服务端同步(供小程序端复用)。
 *
 * @param {number} projectId
 * @param {number} [userId] 有 user.id 才写 per-user key(未登录时跳过)
 */
export function persistCurrentProject(projectId, userId) {
  if (projectId == null || projectId === '') return

  // 1) 全局 key(向后兼容:大量组件直接读它)
  try { localStorage.setItem('currentProjectId', String(projectId)) } catch {}

  // 2) per-user key(账号隔离:退出重登 / A↔B 切号能各恢复各的)
  if (userId) {
    try { localStorage.setItem(`pmwork_current_project_${userId}`, String(projectId)) } catch {}
  }

  // 3) 服务端 —— localStorage 是浏览器私有的,两端不可能共享。
  //    "当前项目"是账号级状态,必须落库,否则小程序端永远要重选。
  //    fire-and-forget:本地已切成功,同步失败不打断 UI,下次切/下次登录会再试。
  //    R-fix-2026-10-22 404 修复:client 的 baseURL 已经是 '/api',
  //    这里再写 '/api/...' 会拼成 '/api/api/auth/...' → 404。
  //    全仓只有这一处犯了同样的错(已 grep 确认)。
  client.put('/auth/me/current-project', { project_id: projectId })
    .catch((e) => {
      console.warn('[sync] current-project 同步失败:', e?.response?.status || e?.message)
    })
}